// extracted by mini-css-extract-plugin
export var label = "_3t-1";
export var reminder = "_3t-0";